<div class="layout-column custom-panel full-width full-height">
  <div class="flex layout-column padding-10">

    <div class="layout-row layout-align-start-center pointer"
         (click)="onToggleSortTypeChange('accountName' , sortBy === 'accountName' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Account Name</span>
      <bringoz-icon *ngIf="sortBy === 'accountName' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'accountName' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         (click)="onToggleSortTypeChange('accountZipCode' , sortBy === 'accountZipCode' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Account Zip Code</span>
      <bringoz-icon *ngIf="sortBy === 'accountZipCode' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'accountZipCode' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         (click)="onToggleSortTypeChange('branchName' , sortBy === 'branchName' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Branch</span>
      <bringoz-icon *ngIf="sortBy === 'branchName' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'branchName' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         (click)="onToggleSortTypeChange('destinationWorkServiceTime' , sortBy === 'destinationWorkServiceTime' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>In-Store Time</span>
      <bringoz-icon *ngIf="sortBy === 'destinationWorkServiceTime' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'destinationWorkServiceTime' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>


    <div class="layout-row layout-align-start-center pointer margin-top-10"
         (click)="onToggleSortTypeChange('deliveryUnits' , sortBy === 'deliveryUnits' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Delivery Units</span>
      <bringoz-icon *ngIf="sortBy === 'deliveryUnits' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'deliveryUnits' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         (click)="onToggleSortTypeChange('totalCalls' , sortBy === 'totalCalls' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Total Services</span>
      <bringoz-icon *ngIf="sortBy === 'totalCalls' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'totalCalls' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

  </div>
</div>
